import { defineStore } from "pinia";

export const useHomeStore = defineStore("home", () => {
  const homeURL = ref<string | undefined>();

  return {
    homeURL,
  };
});
